import { Program } from '@coral-xyz/anchor';
import { Inject, Injectable } from '@nestjs/common';
import { Connection, Keypair } from '@solana/web3.js';
import { Chains } from '@prisma/client';

import bs58 from 'bs58';

import { networkAddresses } from './programs';
import { ProvidersModuleConfig } from './providers.module-definition';
import { Predictions, IDL } from './IDL/prediction-market';

export const PROVIDERS_CONFIG = 'PROVIDERS_CONFIG' as const;

@Injectable()
export class ProvidersService {
  constructor(
    @Inject(PROVIDERS_CONFIG)
    public readonly config: ProvidersModuleConfig,
  ) {}

  getKeypairFromPK(pk: string) {
    return Keypair.fromSecretKey(bs58.decode(pk));
  }

  getProvider() {
    return new Connection(this.config.sol.rpc, 'confirmed');
  }

  getPredictionMarketProgram(chain: Chains) {
    const programId =
      networkAddresses[chain]?.programs.predictionMarket.programId;
    if (!programId)
      throw new Error(
        'Program ID not found, please check your network environment',
      );

    const provider = this.getProvider();
    return new Program<Predictions>(IDL, programId, {
      connection: provider,
    });
  }

  getNetworkAddresses(chain: Chains) {
    return networkAddresses[chain];
  }
}
